var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_23987_20766",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H24C30.6274 0 36 5.37258 36 12V24C36 30.6274 30.6274 36 24 36H12C5.37258 36 0 30.6274 0 24V12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V1H24V0V-1H12V0ZM36 12H35V24H36H37V12H36ZM24 36V35H12V36V37H24V36ZM0 24H1V12H0H-1V24H0ZM12 36V35C5.92487 35 1 30.0751 1 24H0H-1C-1 31.1797 4.8203 37 12 37V36ZM36 24H35C35 30.0751 30.0751 35 24 35V36V37C31.1797 37 37 31.1797 37 24H36ZM24 0V1C30.0751 1 35 5.92487 35 12H36H37C37 4.8203 31.1797 -1 24 -1V0ZM12 0V-1C4.8203 -1 -1 4.8203 -1 12H0H1C1 5.92487 5.92487 1 12 1V0Z",
    fill: "#E5E7EB",
    mask: "url(#path-1-inside-1_23987_20766)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23L15.5 18L20.5 13",
    stroke: "#6A7282",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/Back-Button.868a029824492cb3f3d24ea729498c44.svg";
export { ForwardRef as ReactComponent };